export default "__VITE_ASSET__912c3474__"